import { useEffect, useState, useRef } from 'react'
import Layout from 'components/Layout/Layout'
import Breadcrumb from 'components/Customs/Breadcrumb/index'
import FormContactGlobal from 'components/Customs/Contact/FormContactGlobal'
import FormContactStore from 'components/Customs/Contact/FormContactStore'
import FeaturesSalfa from 'components/CarFile/Information/FeaturesSalfa'
import MapFileCar from 'components/Customs/Mapa/MapFileCar'
import BannerEvent from 'components/Customs/Banner/Horizontal/BannerEvent'
import BannerUpRight from 'components/Customs/Banner/Vertical/BannerUpRight'
import Services from 'components/CarFile/Services/Services'
import Featured from 'components/Customs/Featured/Featured'
import CarouselThumb from 'components/CarFile/CarouselThumb'
import Blog from 'components/Blog/Blog'
import Cards from 'components/Customs/Panels/Cards'
import PanelInformation from 'components/Customs/CardVehicle/PanelInformation'
import ModalSpinner from 'components/Customs/Modal/ModalSpinner'

import MediaQuery from 'react-responsive'
//import ButtonInterested from '../../components/Details/Car/ButtonInterested'
import { getRecommendedCars, getDetailsCar } from 'services/actions/carActions'
import { getListNews } from 'services/actions/blogActions'
import { useFeatured } from 'hooks/useFeatured'
import { useAdvertising } from 'hooks/useAdvertising'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams, useLocation } from 'react-router-dom'
//import { cardCarInfo } from "data/DescripcionHead.json"
import useBreadcrumb from "hooks/Main/useBreadcrumb"
import { useConfig } from "hooks/MetaHead/useConfig"
const CarFileSalfa = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { getDataMetaTag } = useConfig();
  const { advertisingCars, actionAdvertising, getAdvertisingInitial } = useAdvertising()
  const [descriptionMeta, setDescriptionMeta] = useState({});
  const [infoCar, setInfoCar] = useState(location.state?.auto || null);
  const [isLoading, setIsLoading] = useState(false);
  const mapVector = useRef();
  const { cars, blog } = useSelector(state => ({
    cars: state.auto,
    blog: state.blog
  }));

  const { news, loadingPost } = blog;
  useEffect(() => {
    // Si no hay auto, redirige al inicio de Salfa Usados
    if (!infoCar) {
      history.push('/concesionario/salfa-usados');
    } else {
      dispatch(getRecommendedCars(infoCar.typeRecommended));
    }
  }, [infoCar, dispatch, history]);



  if (isLoading) return <ModalSpinner message="Cargando información del auto..." />;
  if (!infoCar) return null;

  // Breadcrumb estático solo para este componente:
  const itemsBreadcrumb = [
    { name: 'Inicio', url: '/' },
    { name: 'Salfa Usados', url: '/concesionario/salfa-usados' },
    { name: `${infoCar.nombreMarca} ${infoCar.nombreModelo}`, url: '' }
  ];
  const goToSelectCar = (key) => {
    history.push(`/concesionario/salfa-usados/${key}`)
  }
  
  return (
    <Layout
      classHeader="row header__white"
      hiddenColor={true}
      isVisibleFooter={true}
      visibleLine={true}
      infoMetaHead={descriptionMeta}
      classDefaultHeader="row header-top header__white"
      classTopHeader=""
    >
      <Breadcrumb
        itemBreadcrumb={itemsBreadcrumb}
        isVisible={true}
        urlReturn="/concesionario/salfa-usados"
      />
      <div className="container">
        <h1 className="page-car__title">{infoCar?.nombreMarca} {infoCar?.nombreModelo} {infoCar?.year}</h1>
      </div>
      <div className="container page-car__section_1">
        <div className="page-car__information">

          <CarouselThumb
            photos={infoCar?.fotos}
            id={infoCar?.idauto}
            isMyRouter={infoCar?.isMyRouter}
            idKey={infoCar?.idauto}
            title={infoCar?.nombreMarca}
            type="autos"
          />
          <Cards
            classContainer="border-0 panel-detail__car"
            classBody="padding-body"
          >
            <PanelInformation
              type="Usados"
              name={`${infoCar?.nombreMarca} ${infoCar?.nombreModelo} ${infoCar?.year}`}
              price={new Intl.NumberFormat('es-CL').format(infoCar?.precio)}
              infoBrand={"ford"}
              isVisibleShare={true}
              mileage={infoCar?.kms}
              transmission={infoCar?.transmisionNombre}
              fuel={infoCar?.combustibleNombre}
              classMain="info-car__description"
              id={infoCar?.idauto}
              typeKey={infoCar?.idauto}
              listPrice={infoCar?.precio}
              priceLockDown={`${infoCar?.moneda} ${new Intl.NumberFormat('es-CL').format(infoCar?.precio)}`}
              listPriceView={new Intl.NumberFormat('es-CL').format(infoCar?.precio)}
              goToConcesionaire={"salfa-usados"}
              isMyRouter={infoCar?.isMyRouter}
              idKey={infoCar?.idauto}
              viewCar={goToSelectCar}
              status_id={"1"}
              stock={true}
            />
          </Cards>

          <MediaQuery minWidth={768}>
            <div className="row">
              <div className="col-12">
                <div className="mt-5 page-car__section_2">
                  <FeaturesSalfa
                    {...infoCar}
                  />
                </div>
              </div>
            </div>
          </MediaQuery>
        </div>


        <div>
          <div className="mb-4">
            <FormContactStore
              isVisibleVIN={false}
              itemService={infoCar}
              styleForm={{
                title: "form-custom__title",
                group: "form-car__group",
                input: "form-car__input",
                labelCheck: "form-car--label",
                groupBtn: "group-contact__car",
                main: "form-contact__car"
              }}
              provider="Salfa Usados"
            />
          </div>
          {advertisingCars.length > 0 &&
            <>
              <BannerEvent
                imagen={advertisingCars[0]}
                functionModal={actionAdvertising}
                title="Banner"
                classContainer="mb-0 mb-md-3 quote-seller__img aspRatio"
                classPicture=""
              />
              <BannerEvent
                imagen={advertisingCars[1]}
                functionModal={actionAdvertising}
                title="Banner"
                classContainer="mb-0 mb-md-3 quote-seller__img aspRatio"
                classPicture=""
              />
              <BannerEvent
                imagen={advertisingCars[2]}
                functionModal={actionAdvertising}
                title="Banner"
                classContainer="mb-0 mb-md-3 quote-seller__img"
                classPicture=""
              />
            </>
          }
          <MediaQuery minWidth={768}>
            <MapFileCar localMap={infoCar?.localMap?.localMap} mapVector={mapVector} />
            {advertisingCars.length > 0 &&
              <BannerUpRight
                imagen={advertisingCars[3]}
                title="Banner"
                functionModal={actionAdvertising}
              />
            }
          </MediaQuery>

        </div>
      </div>


      <Services functionModal={actionAdvertising} />
      {advertisingCars.length > 0 &&
        <BannerEvent
          imagen={advertisingCars[4]}
          functionModal={actionAdvertising}
          title="Banner"
          classContainer="car-banner"
          classPicture="car-banner__detail"
        />
      }



      {isLoading &&
        <ModalSpinner message="Espera un momento, estamos generando la información" />}
    </Layout>
  );
};

export default CarFileSalfa;
